module.exports = __webpack_public_path__ + "static/bellpepper-sm-43b36e9dcc392b47de8497c9d5330979.png";